<template>
  <article class="message is-info">
    <div
      class="message-header is-clickable"
      @click="
        isVisible = !isVisible;
        $emit('change', isVisible);
      "
    >
      {{ title }}
    </div>
    <div v-if="isVisible" class="message-body">
      <slot></slot>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    title: String,
  },

  data() {
    return {
      isVisible: false,
    };
  },
};
</script>
